import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    EntityCacheDispatcher,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator,
    Logger,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { WebsocketBrokerService } from '../../../core/services/websocket-broker.service';
import { WebSocketEntityCollectionServiceBase } from '../../../state/entity/web-socket-entity-collection-service-base';

import { BsModalService } from 'ngx-bootstrap/modal';
import { DateAppointmentService } from '../../appointments/state/date-appointment.service';
import { PatientAppointmentService } from '../../patients/state/patient-appointment.service';
import { RemindersReportEntityDataServiceBase } from './reminders-report-entity-data-service.base';
import { remindersReportEntityMetadata } from './reminders-report.entity';

@Injectable()
export class RemindersReportService extends WebSocketEntityCollectionServiceBase<any> {

    refreshing$: Observable<boolean>;

    constructor(private http: HttpClient,
                private serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super(remindersReportEntityMetadata.entityName, serviceElementsFactory);
        this.refreshing$ = this.selectors$['refreshing$'];
    }
}

/**
 * This is the data service NgRx Data will use to call from effects to make the actual calls to the backend.
 */
@Injectable()
export class RemindersReportEntityDataService extends RemindersReportEntityDataServiceBase<any> {
    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService,
                public dateAppointmentService: DateAppointmentService,
                public patientAppointmentService: PatientAppointmentService,
                public modalService: BsModalService) {
        super(http, httpUrlGenerator, logger, entityCacheDispatcher, websocketBrokerService, dateAppointmentService,
            patientAppointmentService, 'AppointmentList', 'appointment-list-reminders-report/', modalService);
        logger.log('Created custom Appointment List Reminders Report EntityDataService');
    }

    subscribeWebSocketJob(parameters: any | QueryParams): void {
        this.subscribeWebSocketJobWithBody({parameters});
    }

    refreshWebSocketJob(parameters: any | QueryParams): void {
        this.refreshWebSocketJobWithBody({parameters});
    }
}
